import RdwVoting from './RdwVoting';
export default RdwVoting;
